<div class="web-style-top-bar-wrapper">
  <div class="logo-container">
    <img class="logo" src="../../assets/images/AQ_Logo_White.svg" alt="logo">
  </div>
  <div class="page-title">
    {{pageTitle}}
  </div>
</div>
